"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function keyDownEventPropsNormalizer(keyDownEvent) {
    var eventKey = keyDownEvent.key;
    if (keyDownEvent.keyCode === 229) {
        eventKey = 'Process';
    }
    return {
        key: eventKey,
    };
}
exports.default = keyDownEventPropsNormalizer;
